import React, { useContext, useState } from 'react'
import { AuthContext } from '../../../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { LoginOutlined } from '@ant-design/icons';
import Profile from './Profile';

export default function Wrapper() {
    const { token } = useContext(AuthContext);
    const [isVisible, setVisible] = useState(false) 
  return (
    <div className="flex flex-row items-center">
    {token ? (
      <div className="z-50">
        <Profile isVisible={isVisible} setVisible={setVisible} />
      </div>
    ) : (
      <Link
        to={"/"}
        className="mx-4 flex justify-center items-center text-white rounded-md py-1"
      >
        <LoginOutlined color="#FFFFFF" size={22} />
      </Link>
    )}
  </div>
  )
}
